import { Injectable } from '@angular/core';
import { AppComponent } from './../app.component';
import 'rxjs/Rx';

@Injectable()
export class DownloadManager {

    prepareDownload(data, file_name, mime_type) {
        const blob: Blob = this.prepareBlobForDownload(data, mime_type);
        const whoIsIt = this.everybodyHatesInternetExplorer(data, file_name);
        if (whoIsIt === 'notIE') {
            this.civilizatedDownload(blob, file_name);
        }
    }

    prepareBlobForDownload(data, mime_type) {
        const result: String = atob(data);
        const buffer: ArrayBuffer = new ArrayBuffer(result.length);
        const bufferView: Uint8Array = new Uint8Array(result.length);
        for (let i = 0; i < result.length; i++) {
            bufferView[i] = result.charCodeAt(i);
        }
        return new Blob([bufferView], {type: mime_type});
    }

    civilizatedDownload(blob: Blob, file_name) {
        const blobUrl: string = window.URL.createObjectURL(blob);
        const element = document.createElement('a');
        element.setAttribute('href', blobUrl);
        element.setAttribute('download', file_name);
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }

    everybodyHatesInternetExplorer(blob: Blob, file_name) {
        const ie = navigator.userAgent.match(/MSIE\s([\d.]+)/);
        const ie11 = navigator.userAgent.match(/Trident\/7.0/) && navigator.userAgent.match(/rv:11/);
        const ieEDGE = navigator.userAgent.match(/Edge/g);
        let ieVer;

        if (ie) {
            ieVer = ie[1];
        } else {
            if (ie11) {
                ieVer = 11;
            } else {
                if (ieEDGE) {
                    ieVer = 12;
                } else {
                    ieVer = -1;
                }
            }
        }
        if (ie && ieVer < 10) {
            console.log('No blobs on IE ver < 10 :-( )');
            return 'ieFAIL';
        } else if (ieVer > -1) {
            window.navigator.msSaveBlob(blob, file_name);
            return 'ieSUCCESS';
        } else {
            return 'notIE';
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/manager/download.manager.ts